/** Outlined "Next Step" card surfacing what's coming up. The eyebrow defaults to "Next Step" but is overridable. */
export function NextStepCard({
  eyebrow = 'Next Step',
  body,
}: {
  eyebrow?: string | undefined;
  body: string;
}) {
  return (
    <div className="space-y-1 rounded-xl border p-3">
      <p className="text-foreground text-xs font-semibold">{eyebrow}</p>
      <p className="text-muted-foreground text-xs leading-5">{body}</p>
    </div>
  );
}
